export var ExportStatusType = /*#__PURE__*/ function(ExportStatusType) {
    ExportStatusType["TaskExport"] = "TASK_LIST_EXPORT";
    ExportStatusType["ProjectExport"] = "PROJECT_LIST_EXPORT";
    ExportStatusType["TimesheetReportExport"] = "TIMESHEET_REPORT_EXPORT";
    ExportStatusType["CustomReportExport"] = "CUSTOM_REPORTS_EXPORT";
    return ExportStatusType;
}({});
export var ExportQueueStatus = /*#__PURE__*/ function(ExportQueueStatus) {
    ExportQueueStatus["Submitted"] = "SUBMITTED";
    ExportQueueStatus["InProgress"] = "IN_PROGRESS";
    ExportQueueStatus["Completed"] = "COMPLETED";
    ExportQueueStatus["Failed"] = "FAILED";
    return ExportQueueStatus;
}({});
